<template>
  <div>
    <button
      type="button"
      class="btn btn-primary bi bi-card-checklist d-none"
      tabindex="-1"
      aria-hidden="true"
      data-toggle="modal"
      data-target="#miw-guid-modal"
    >
      guid
    </button>

    <div class="modal fade" id="miw-guid-modal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">گاید</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-left" dir="ltr">
            <h5>save => ctrl+s</h5>
            <h5>build css => ctrl+q</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ManualGuid"
}
</script>
